import { Link } from 'react-router-dom';
import { articleCards } from '@/mocks/homeData';

export default function ArticleCards() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Latest Basetao Guides & Articles
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            In-depth SEO articles covering everything from shipping costs to platform reviews — all designed to help you shop smarter
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articleCards.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col bg-white border border-background-200 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="w-full aspect-video overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-[10px] font-medium px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full">
                    {article.category}
                  </span>
                  <span className="text-[10px] text-foreground-500">{article.readTime}</span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-150 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between pt-3 border-t border-background-100">
                  <span className="text-[11px] text-foreground-500 flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.date}
                  </span>
                  <span className="text-xs font-medium text-primary-600 flex items-center gap-1 group-hover:gap-2 transition-all duration-200">
                    Read More
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}